import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'catalogSelectionDeck.edxSubscription.label': {
    id: 'catalogSelectionDeck.edxSubscription.label',
    defaultMessage: 'Subscription',
    description: 'label for checkbox for filtering results',
  },
  'catalogSelectionDeck.labelDetail': {
    id: 'catalogSelectionDeck.edxForOnlineEdu.labelDetail',
    defaultMessage: 'Single, per learner price',
    description: 'secondary label for checkbox for filtering results',
  },
  'catalogSelectionDeck.bullet1': {
    id: 'catalogSelectionDeck.edxForBusiness.bullet1',
    defaultMessage:
      'Unlimited access to 2,000+ courses',
    description: 'description of filter',
  },
  'catalogSelectionDeck.bullet2': {
    id: 'catalogSelectionDeck.edxForBusiness.bullet2',
    defaultMessage:
      'Professional certificates and select programs',
    description: 'description of filter',
  },
  'catalogSelectionDeck.bullet3': {
    id: 'catalogSelectionDeck.edxForBusiness.bullet3',
    defaultMessage:
      'Self-paced courses',
    description: 'description of filter',
  },
  'catalogSelectionDeck.aLaCarte.badge': {
    id: 'catalogSelectionDeck.aLaCarte.badge',
    defaultMessage: 'For all organizations',
    description: 'badge for catalog',
  },
  'catalogSelectionDeck.aLaCarte.label': {
    id: 'catalogSelectionDeck.aLaCarte.label',
    defaultMessage: 'A la carte',
    description: 'label for checkbox for filtering results',
  },
  'catalogSelectionDeck.aLaCarte.labelDetail': {
    id: 'catalogSelectionDeck.aLaCarte.labelDetail',
    defaultMessage: 'Individually priced courses and programs',
    description: 'label for checkbox for filtering results',
  },
  'catalogSelectionDeck.aLaCarte.bullet1': {
    id: 'aLaCarte.bullet1',
    defaultMessage:
      'Select from all 3,000+ courses available on edX including all programs and certificates',
    description: 'description of filter',
  },
  'catalogSelectionDeck.aLaCarte.bullet2': {
    id: 'aLaCarte.bullet2',
    defaultMessage:
      'Self-paced and instructor-paced courses',
    description: 'description of filter',
  },
});

export default messages;
